import * as Effect from "effect/Effect";
import * as Layer from "effect/Layer";
import { isNonInteractive } from "../Util/interactive.js";
import { LoggingCli } from "./LoggingCli.js";
export { isNonInteractive } from "../Util/interactive.js";
export const selectCli = () => isNonInteractive()
    ? LoggingCli
    : // Defer importing the Ink/React TUI (`./tui/InkCLI.tsx` pulls in `ink`)
        // until we actually need the interactive renderer. Non-interactive runs
        // (agents, CI, piped output) take the cheap `LoggingCli` branch and never
        // pay the TUI import cost.
        Layer.unwrap(Effect.promise(() => import("./tui/InkCLI.js").then((m) => m.inkCLI())));
//# sourceMappingURL=selectCli.js.map